/**
 * TriangleUpIcon/index.js
 * desc: dropdown triangle icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const TriangleUpIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="triangle-up icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.triangleUp.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 10 5" xmlns="http://www.w3.org/2000/svg"><path d="m0 5 5-5 5 5H0Z"/></svg>
    </IconButton>
);


export default TriangleUpIcon;
